import { fromJS } from "immutable";

export const STATE_WEBVIEW = "webview";
export const STATE_WEBVIEW_IS_INPUT_DISABLED = "isInputDisabled";
export const STATE_WEBVIEW_IS_FOCUS = "isFocus";
export const STATE_WEBVIEW_IS_SKIP_USER_INPUT = "isSkipUserInput";

export const STATE_WEBVIEW_DEFAULT = fromJS({
  [STATE_WEBVIEW_IS_INPUT_DISABLED]: false,
  [STATE_WEBVIEW_IS_FOCUS]: false,
  [STATE_WEBVIEW_IS_SKIP_USER_INPUT]: false,
});
